import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: 'app-card-scroller',
    templateUrl: './card-scroller.component.html',
    styleUrls: ['./card-scroller.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardScrollerComponent {
    @Input() header = ''

}